var treeBindV2 = { item: '=', caller: '=', level: '=', parent: '=' };
var DetailTreeV2Controller = (function () {
    function DetailTreeV2Controller(topic, settings) {
        this.topic = topic;
        this.settings = settings;
        this.visible = true;
    }
    ;
    DetailTreeV2Controller.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTreeV2Controller.prototype.rbr = function (v) {
        if (v) {
            return v.replace(/<br>/g, '\n');
        }
    };
    DetailTreeV2Controller.prototype.isAvailable = function () {
        return this.caller === 'payment' && this.level === 4;
    };
    DetailTreeV2Controller.prototype.isCtlSo24Plus = function () {
        return this.item.bonusType === 'ctl_so_24_plus';
    };
    DetailTreeV2Controller.prototype.isPayedByForecast = function () {
        return this.item.payedBy === 'forecast';
    };
    DetailTreeV2Controller.prototype.isPayedBySo = function () {
        return this.item.payedBy === 'so';
    };
    DetailTreeV2Controller.prototype.isVer3AndMore = function () {
        return this.topic.checksData.uiVersion >= 3;
    };
    DetailTreeV2Controller.prototype.isVer4AndMore = function () {
        return this.topic.checksData.uiVersion >= 4;
    };
    DetailTreeV2Controller.prototype.isVerLess4 = function () {
        return this.topic.checksData.uiVersion < 4;
    };
    DetailTreeV2Controller.prototype.getTotalForecastAmount = function () {
        return this.item.bfTotalForecast !== undefined ? this.item.bfTotalForecast : this.item.amountLC;
    };
    DetailTreeV2Controller.prototype.isNotAutoForecasts = function () {
        var id = this.isVer3AndMore() ? this.parent.parent.item.drpgId : this.parent.parent.item.brandCode;
        return this.topic.topic.calculation.forecasts[id].auto === false;
    };
    DetailTreeV2Controller.prototype.isNotAutoPayed = function () {
        var id = this.isVer3AndMore() ? this.parent.parent.item.drpgId : this.parent.parent.item.brandCode;
        return this.topic.topic.calculation.payed[id].auto === false;
    };
    DetailTreeV2Controller.prototype.getAlreadyPaidAmount = function () {
        var parIt = this.parent.parent.item;
        var calc = this.topic.topic.calculation;
        if (this.isVer3AndMore()) {
            return calc.payed[parIt.drpgId].value;
        }
        return calc.payed[parIt.brandCode || parIt.id].value;
    };
    DetailTreeV2Controller.prototype.getTotalAmount = function () {
        var parIt = this.parent.parent.item;
        var calc = this.topic.topic.calculation;
        if (this.isVer3AndMore()) {
            return calc.dealRegistrationProductGroups[parIt.drpgId].amount;
        }
        var brFams = calc.brandFamilies;
        return brFams[parIt.brandCode].amount !== undefined ? brFams[parIt.brandCode].amount : brFams[parIt.id].amount;
    };
    DetailTreeV2Controller.prototype.getUpliftedAmountHeader = function (flag) {
        var item = (flag === 'ctlSo' && this.item.ctlSo) ? this.item.ctlSo : this.item;
        return item.baseAmount.isBaseAmount
            ? 'Uplifted Amount (ZFN4)'
            : "Uplift " + item.upliftSo + "% (" + this.parent.parent.parent.item.currency + ")";
    };
    DetailTreeV2Controller.prototype.getCurrency = function () {
        return this.topic.topic.calculation.goe === "Y"
            ? this.parent.parent.parent.item.currency
            : this.topic.topic.calculation.forecasts.currency;
    };
    DetailTreeV2Controller.$inject = ['topic', 'settings'];
    return DetailTreeV2Controller;
}());
var DetailTreeV2Component = (function () {
    function DetailTreeV2Component() {
        this.bindings = treeBindV2;
        this.templateUrl = 'detail-tree-v2.html';
        this.controller = DetailTreeV2Controller;
    }
    return DetailTreeV2Component;
}());
angular
    .module('application')
    .component('detailTreeV2Section', new DetailTreeV2Component())
    .directive('bonusPercentage', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(attrs.bonusPercentage, function (value) {
                element.text(value ? "Bonus " + value + "% (" + attrs.currency + ")" : 'N/A');
            });
        }
    };
})
    .directive('bonusAmount', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(attrs.bonusAmount, function (value) {
                if (value > 0 || value < 0) {
                    element.addClass(value > 0 ? 'ibm-textcolor-green-50' : 'ibm-textcolor-red-50');
                }
                element.text(value || 'N/A');
            });
        }
    };
});

//# sourceMappingURL=detail.tree.v2.component.js.map
